(function ($, Drupal) {
  Drupal.behaviors.staggeredGridFormatterV1 = {
    attach: function (context) {
      var $formatters = $('.js-staggered-grid-formatter-v1', context);
      var isDesktop = Unison.fetch.now().name !== 'small';

      $formatters.each(function () {
        var $formatter = $(this);
        var $headline = $('.staggered-grid-formatter__headline', $formatter);
        var $items = $('.staggered-grid-formatter__grid-item', $formatter);

        // If this is a 50/50 display get out of here
        if ($formatter.hasClass('staggered-grid-formatter--50-50')) {
          return;
        }
        // Default style moves the headline into the first tout.
        if (isDesktop && $items.length) {
          $headline.attr('style', '').prependTo($items.first());
        }
        if (isDesktop) {
          return;
        }
        $items.each(function () {
          var $item = $(this);
          var $imageColumn = $('.js-staggered-grid-tout-media', $item);
          var $contentColumn = $('.js-staggered-grid-tout-content', $item);
          var $truncate = $('.js-staggered-grid-tout-content-line', $item);

          // Get the space left
          $truncate.hide();
          var shaveAmount = $imageColumn.innerHeight() - $contentColumn.innerHeight();

          $truncate.show();
          if (shaveAmount < 65) {
            shaveAmount = 65;
          }
          $('.staggered-grid-tout__content-text').shave(shaveAmount);
        });
      });
    }
  };
})(jQuery, Drupal);
